import { render, staticRenderFns } from "./TANav-En.vue?vue&type=template&id=afb4d6c6&scoped=true&"
import script from "./TANav-En.vue?vue&type=script&lang=js&"
export * from "./TANav-En.vue?vue&type=script&lang=js&"
import style0 from "./TANav-En.vue?vue&type=style&index=0&id=afb4d6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb4d6c6",
  null
  
)

export default component.exports